import {
  AssetAggregatesStacked,
  SmartReportEntity,
  SmartReportEntityTypeEnum,
} from '@/types/GraphqlSchema';

export type AssetAggregatesStackedResponse = {
  assetAggregatesStacked: AssetAggregatesStacked;
};

export type SmartReportEntityExtended = SmartReportEntity & {
  type: SmartReportEntityTypeEnum;
};

export enum SmartReportTypeEnum {
  Asset = 'Asset',
  Country = 'CountryArea',
  Corporate = 'Corporate',
}

export enum SmartReportComponentTypesEnum {
  TextField = 'text_field',
  TextArea = 'text_area',
  Chart = 'chart',
  Table = 'table',
  Image = 'image',
}

export enum SmartReportLayoutIdsEnum {
  TitlePage = 'title_page',
  FullPage = 'full_page',
  FullWidth = 'full_width',
  SideBySide = 'side_by_side',
  TwoRowSlots = 'two_row_slots',
  TwoRowThreeSlots = 'two_row_three_slots',
  TwoRowFourSlots = 'two_row_four_slots',
  FourRowEightSlots = 'four_row_eight_slots',
}
